<template lang="html">
  <PageHeader />
  <div v-if="isLoading">
    <Loader />
  </div>
  <section class="forget-password account-section mt-stickybar mb-5 home">
    <div class="account-banner text-center"><img src="@/assets/images/signup.png" alt="" /></div>
    <div class="container">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="card shadow-lg border-0 rounded-4 mt-5 bg-whitesmoke">
        <div class="card-body p-4">
          <h2 class="text-center mb-3">Forgot your password?</h2>
          <p class="text-center mb-3">Enter your email to receive a reset link.</p>

          <div class="form-group">
            <label for="email" class="form-label">Email address</label>
            <input type="email" id="email" v-model="resetEmail.email"
              class="form-control rounded-pill bg-white" placeholder="Enter your email" />
            <span class="text-danger pl-3" v-if="v$.email.$error">
              <!-- {{ $t('errorMessage', { text: $t('mail') }) }}* -->
            </span>
          </div>

          <div class="text-center mt-4">
            <button type="submit" class="btn btn-primary w-70 rounded-pill px-4 py-2" @click="reset()">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  </section>
  <PageFooter />
</template>

<script lang="js">

import {
  ref, computed, reactive,
} from 'vue';
import { useRouter } from 'vue-router';
import useVuelidate from '@vuelidate/core';
import {
  required, numeric, email, minLength, helpers,
} from '@vuelidate/validators';

import Loader from '@/components/commons/Loader.vue';
import SvgButton from '@/components/partials/SvgButton.vue';
import StoryphoneService from '@/services/StoryphoneService';
import AuthenticationService from '@/services/AuthenticationService';

const authenticationService = new AuthenticationService();

export default {
  name: 'forget-password',
  props: [],
  components: {
    Loader,
    // SvgButton,

  },
  setup() {
    const resetEmail = reactive({
      email: '',
    });
    const isLoading = ref(false);
    const router = useRouter();

    const rules = {
      email: { required: helpers.withMessage('You must enter your email', required), email },

    };

    const v$ = useVuelidate(rules, resetEmail);

    const reset = async () => {
      const result = await v$.value.$validate();
      if (result) {
        isLoading.value = true;
        const data = { email: resetEmail.email };
        authenticationService.resetPasswordEmail(data)
          .then(() => {
            isLoading.value = false;
            router.push('/reset-password-email');
          })
          .catch((error) => {
            isLoading.value = false;
          });
      }
    };

    return {
      isLoading, reset, v$, resetEmail,
    };
  },
};
</script>

<style scoped lang="scss"></style>
